import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from "../../components/customAxios";
import baseUrl from "../../../base_url";

/**
 * ProtectedRoute — wraps any admin page that requires authentication.
 * Shows a loading spinner while verifying the token, then either
 * renders children or redirects to login.
 */
const ProtectedRoute = ({ children }) => {
  const [authState, setAuthState] = useState("loading"); // "loading" | "authenticated" | "unauthenticated"

  useEffect(() => {
    let cancelled = false;

    const checkAuth = async () => {
      try {
        await axios.get(`${baseUrl}api/admin/checkLogin`, {
          withCredentials: true,
        });
        if (!cancelled) setAuthState("authenticated");
      } catch {
        if (!cancelled) setAuthState("unauthenticated");
      }
    };

    checkAuth();

    return () => {
      cancelled = true;
    };
  }, []);

  if (authState === "loading") {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-500 border-t-transparent" />
          <span className="text-gray-500 text-sm">Verifying session…</span>
        </div>
      </div>
    );
  }

  if (authState === "unauthenticated") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
